import { Action } from './Action/action.js';
import { ActionGroup } from './ActionGroup/action-group.js';
import { AssistantMessage } from './AssistantMessage/assistant-message.js';
import { Card } from './Card/card.js';
import { CardGroup } from './CardGroup/card-group.js';
import { Event } from './Event/event.js';
import { EventGroup } from './EventGroup/event-group.js';
import { File } from './File/file.js';
import { FormRecap } from './FormRecap/FormRecap.js';
import { FormRecapError } from './FormRecapError/FormRecapError.js';
import { FormRecapSuccess } from './FormRecapSuccess/FormRecapSuccess.js';
import { FormRequest } from './FormRequest/FormRequest.js';
import { Image } from './Image/image.js';
import { NotFound } from './NotFound/not-found.js';
import { Poi } from './Poi/poi.js';
import { PoiGroup } from './PoiGroup/poi-group.js';
import { Product } from './Product/product.js';
import { ProductGroup } from './ProductGroup/product-group.js';
import { ProductGroupSlider } from './ProductGroupSlider/product-group-slider.js';
import { StreamError } from './StreamError/StreamError.js';
import { TripAdvisor, TripAdvisorGroup } from './Tripadvisor/tripadvisor.js';
import { UserMessage } from './UserMessage/user-message.js';

const LLM_BLOCKS = {
  action: Action,
  actionGroup: ActionGroup,
  assistantMessage: AssistantMessage,
  card: Card,
  cardGroup: CardGroup,
  event: Event,
  eventGroup: EventGroup,
  file: File,
  formRecap: FormRecap,
  formRecapError: FormRecapError,
  formRecapSuccess: FormRecapSuccess,
  formRequest: FormRequest,
  image: Image,
  notFound: NotFound,
  poi: Poi,
  poiGroup: PoiGroup,
  product: Product,
  productGroup: ProductGroup,
  productGroupSlider: ProductGroupSlider,
  error: StreamError,
  tripAdvisor: TripAdvisor,
  tripAdvisorGroup: TripAdvisorGroup,
  userMessage: UserMessage
};

export { LLM_BLOCKS };
//# sourceMappingURL=index.js.map
